import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.css'],
    standalone: false
})
export class PopUpComponent {

  constructor(private dialogRef: MatDialogRef<PopUpComponent>) {}

  cerrarModal() {
      this.dialogRef.close();
  }
}
